<span class="sort-header">
  {{ label }}
  <ng-container
    *ngIf="
      currentTableOrder === orderCriteria + ':a' ||
      currentTableOrder === orderCriteria + ':d'
    "
  >
    <i
      class="fas"
      [class.fa-arrow-up]="currentTableOrder === orderCriteria + ':a'"
      [class.fa-arrow-down]="currentTableOrder === orderCriteria + ':d'"
    >
    </i>
  </ng-container>
</span>
